import script from "./manualInspection1.vue?vue&type=script&setup=true&lang=ts"
export * from "./manualInspection1.vue?vue&type=script&setup=true&lang=ts"

import "./manualInspection1.vue?vue&type=style&index=0&id=199c8b50&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-199c8b50"]])

export default __exports__